import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import { LIST_COUNTRIES } from '@/utils';

const SUPPORTED_COUNTRIES = LIST_COUNTRIES.filter((country) => {
  return (
    country.name !== 'United Kingdom' &&
    country.name !== 'Norway' &&
    country.name !== 'Switzerland'
  );
});
export const SupportedCountries = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h3 className="h3">
        {t('multibanking-platform.supported-countries.title')}
      </h3>
      <p className="body2-blog mt-3">
        {t('multibanking-platform.supported-countries.text')}
      </p>
      <ul className="mt-8 grid grid-flow-col grid-cols-2 grid-rows-14 justify-between gap-x-[48px] md:grid-cols-3 md:grid-rows-9">
        {SUPPORTED_COUNTRIES.map((country) => (
          <li
            key={country.iso2}
            className="body2 flex items-center gap-2 py-3 font-[425] text-blue-900"
          >
            <Image
              src={country.flag}
              alt="language"
              className="max-h-[15px] min-h-[15px] min-w-[20px] max-w-[20px] rounded-sm"
            />
            {t(`database.countries.${country.name}`)}
          </li>
        ))}
      </ul>
    </div>
  );
};
